import React, { useState } from 'react';
import { Modal, Button, Spinner } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const ResumeSelectionPopup = ({ resumes, onSelectResume, show, onClose, userName, userId, isLoading }) => {
    const [selectedResume, setSelectedResume] = useState('');
    const [errMessage, setErrMessage] = useState('');

    const handleSelectChange = (event) => {
        setSelectedResume(event.target.value);
    };

    const handleApplyClick = () => {
        if (selectedResume) {
            onSelectResume(selectedResume);
            onClose();
        } else {
            setErrMessage("Please select a resume.");
        }
    };

    return (
        <Modal show={show} onHide={onClose}>
            <Modal.Header closeButton>
                <Modal.Title>Select Resume</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                {isLoading ? (
                    <div className="d-flex align-items-center">
                        <Spinner animation="border" size="sm" className="me-2" />
                        <span>Loading resumes...</span>
                    </div>
                ) : resumes.length === 0 ? (
                    <p className="text-danger">Please enter your resume first.</p>
                ) : (
                    <>
                        <select
                            id="resumeSelect"
                            value={selectedResume}
                            onChange={handleSelectChange}
                            className="form-select"
                        >
                            <option value="" disabled style={{ color: '#2729bd', cursor: 'not-allowed' }}>
                                Select Resume
                            </option>
                            {resumes.map((resume) => (
                                <option key={resume.id} value={resume.id}>
                                    {resume.message}
                                </option>
                            ))}
                        </select>

                        {errMessage && <p className="error-message text-danger mt-2">{errMessage}</p>}
                    </>
                )}
            </Modal.Body>

            <Modal.Footer>
                {!isLoading && resumes.length === 0 ? (
                    <Link
                        to="/candidate-dashboard/resume/resumeAdd"
                        state={{ userName: userName, userId: userId }}
                    >
                        <Button variant="secondary">ADD RESUME</Button>
                    </Link>
                ) : (
                    !isLoading && (
                        <Button variant="primary" onClick={handleApplyClick}>
                            Apply
                        </Button>
                    )
                )}
            </Modal.Footer>
        </Modal>
    );
};

export default ResumeSelectionPopup;
